import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export function HomeSkeleton() {
  return (
    <Box
      component="main"
      id="main"
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Skeleton variant="rectangular" width={240} height={48} />
    </Box>
  );
}
